import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import RippleButton from "../../components/common/RippleButton";
import {
  clearLeadDetails,
  clearLeadFilterDetails,
  setactiveTabIndex,
  setLeadFilterDetails,
} from "./leadSlice";
import ButtonForAll from "../../components/common/ButtonForAll";
import { getAllActiveLeadSource } from "../leadsource/services/leadsource.service";
import { ILeadSource } from "../leadsource/leadsourceModel";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { ILeadStage } from "../leadstage/leadStageModel";
import { IUser } from "../user/userModel";
// import FormCheckbox from "../../components/formFields/FormCheckbox";
import IconComponent from "../../components/common/IconComponent";
import { FaFilter } from "react-icons/fa";
import { Button } from "@progress/kendo-react-buttons";
import { useLocation } from "react-router-dom";
import { LEADTYPE } from "../../_contstants/common";

const LeadFilter: React.FC = () => {
  // const gridRef = useRef<any>(null);
  const BTNRef = useRef<any>(null);

  const dispatch = useAppDispatch();
  const location = useLocation();
  const ContactID = location.state?.ContactID;
  const loading = useAppSelector((state) => state.lead.loading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const [expand, setExpand] = useState("");
  const LeadFilterDetails = useAppSelector(
    (state) => state.lead.LeadFilterDetails
  );
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );
  const LeadStageList = useAppSelector(
    (state) => state.leadStage.LeadStageList
  );
  const activeTabIndex = useAppSelector((state) => state.lead.activeTabIndex);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [LeadFilterDetails]);

  // useEffect(() => {
  //   dispatch(getAllActiveLeadSource());

  //   if (ContactID) {
  //     dispatch(
  //       setLeadFilterDetails({
  //         ...LeadFilterDetails,
  //         filterFromDate: LeadFilterDetails?.filterFromDate
  //           ? moment(LeadFilterDetails?.filterFromDate, "YYYY-MM-DD")?.toDate()
  //           : "",
  //         filterToDate: LeadFilterDetails?.filterToDate
  //           ? moment(LeadFilterDetails?.filterToDate, "YYYY-MM-DD")?.toDate()
  //           : "",
  //         filterContactID: `${ContactID || ""}`,
  //       })
  //     );
  //   }

  //   return () => {
  //     dispatch(clearLeadDetails());
  //   };
  // }, []);

  useEffect(() => {
    dispatch(getAllActiveLeadSource());

    // Only set filter details if ContactID exists to avoid triggering duplicate API calls
    if (ContactID && !LeadFilterDetails?.filterContactID) {
      dispatch(
        setLeadFilterDetails({
          ...LeadFilterDetails,
          filterFromDate: LeadFilterDetails?.filterFromDate
            ? moment(LeadFilterDetails?.filterFromDate, "YYYY-MM-DD")?.toDate()
            : "",
          filterToDate: LeadFilterDetails?.filterToDate
            ? moment(LeadFilterDetails?.filterToDate, "YYYY-MM-DD")?.toDate()
            : "",
          filterContactID: `${ContactID || ""}`,
        })
      );
    }

    return () => {
      dispatch(clearLeadDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    const insertPayload = {
      filterNoOfNights: values?.filterNoOfNights
        ? +values?.filterNoOfNights
        : null,
      filterSectorID: values?.filterSectorID ? `${values?.filterSectorID}` : "",
      filterLeadStageID: values?.filterLeadStageID
        ? +values?.filterLeadStageID
        : null,
      filterLeadSourceID: values?.filterLeadSourceID
        ? +values?.filterLeadSourceID
        : null,
      filterName: values?.filterName ? values?.filterName : "",
      filterLeadType: values?.filterLeadType ? values?.filterLeadType : "",
      filterMobileNo: values?.filterMobileNo ? `${values?.filterMobileNo}` : "",
      filterEmailID: values?.filterEmailID ? values?.filterEmailID : "",
      filterAssignedTo: values?.filterAssignedTo
        ? +values?.filterAssignedTo
        : null,
      filterUnassignedLeads: values?.filterUnassignedLeads
        ? values?.filterUnassignedLeads
        : false,
      filterFromDate: values?.filterFromDate
        ? moment(values?.filterFromDate)?.format("YYYY-MM-DD")
        : "",
      filterToDate: values?.filterToDate
        ? moment(values?.filterToDate)?.format("YYYY-MM-DD")
        : "",
      filterContactID: LeadFilterDetails?.filterContactID || ContactID || "",
    };
    if (values?.filterLeadStageID === 1 || values?.filterLeadStageID === 2) {
      dispatch(
        setactiveTabIndex(
          values?.filterLeadStageID === 1
            ? 0
            : values?.filterLeadStageID === 2
            ? 1
            : null
        )
      );
    }
    setExpand("");
    dispatch(setLeadFilterDetails(insertPayload));
  };

  return (
    <>
      {/* {loading && <LoadingPanel gridRef={gridRef} />} */}

      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={{
          ...LeadFilterDetails,
          filterFromDate: LeadFilterDetails?.filterFromDate
            ? moment(LeadFilterDetails?.filterFromDate, "YYYY-MM-DD")?.toDate()
            : "",
          filterToDate: LeadFilterDetails?.filterToDate
            ? moment(LeadFilterDetails?.filterToDate, "YYYY-MM-DD")?.toDate()
            : "",
        }}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ExpansionPanel
              className="inquiry-filter-panel m-0"
              title={
                <div>
                  <div>
                    <IconComponent icon={FaFilter} /> Filter Results
                  </div>
                </div>
              }
              expanded={expand === "filter"}
              tabIndex={1}
              onAction={(event: ExpansionPanelActionEvent) => {
                const nativeEvent = event.nativeEvent as KeyboardEvent;
                const ActiveBTN = document.activeElement as HTMLElement;

                if (
                  nativeEvent.type === "keydown" &&
                  nativeEvent.code === "Space"
                ) {
                  nativeEvent.preventDefault();
                  return;
                } else if (
                  nativeEvent.code === "Enter" ||
                  nativeEvent.code === "NumpadEnter"
                ) {
                  nativeEvent.preventDefault();
                  if (ActiveBTN.id === "LeadSubmitBtn") {
                    BTNRef.current.element.click();
                  } else if (ActiveBTN.id === "ClearLeadDetail") {
                    setExpand("");
                  }
                  return;
                }

                if (event?.expanded) {
                  setExpand("");
                } else {
                  setExpand("filter");
                }
              }}
            >
              {expand === "filter" && (
                <GridLayout
                  style={{ marginRight: 20, padding: 10 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterLeadStageID"}
                      name={"filterLeadStageID"}
                      label={"Lead stage"}
                      placeholder="Lead stage"
                      disabled={activeTabIndex === 0 || activeTabIndex === 1}
                      component={FormSelectionField}
                      options={LeadStageList?.map((leadstage: ILeadStage) => {
                        return {
                          value: leadstage?.ID,
                          label: leadstage?.LeadStage,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterLeadSourceID"}
                      name={"filterLeadSourceID"}
                      label={"Lead Source"}
                      placeholder="Lead Source"
                      component={FormSelectionField}
                      options={LeadSourceList?.map(
                        (leadsource: ILeadSource) => {
                          return {
                            value: leadsource?.ID,
                            label: leadsource?.Source,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterName"
                      label="Customer Name"
                      placeholder="Customer Name"
                      maxLength="100"
                      component={FormTextField}
                      onKeyDown={(e: any) => {
                        if (e.key === " ") {
                          formRenderProps.onChange("filterName", {
                            value: `${e?.target?.value} `,
                          });
                        }
                      }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterMobileNo"
                      label="Mobile No"
                      type="number"
                      placeholder="i.e. 9999999999"
                      max={10}
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterEmailID"
                      label="Email ID"
                      placeholder="i.e. example@gmail.com"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterAssignedTo"
                      label="Assigned To"
                      placeholder="assigned To"
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => ({
                        value: user?.ID,
                        label: `${user?.FirstName} ${user?.LastName}`,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={"filterFromDate"}
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={"filterToDate"}
                      label="To Date"
                      format="dd/MM/yyyy"
                      disabled={!formRenderProps.valueGetter("filterFromDate")}
                      component={FormDatePicker}
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate")
                      ).toDate()}
                    />
                  </GridLayoutItem>
                  {/* <GridLayoutItem>
                    <Field
                      wrapperStyle={{ marginTop: 35 }}
                      name="filterUnassignedLeads"
                      label="Un-Assigned"
                      placeholder="Un-Assigned"
                      component={FormCheckbox}
                    />
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                    <Field
                      name={"filterLeadType"}
                      label={"Lead Type"}
                      placeholder="i.e. B2B"
                      component={FormSelectionField}
                      options={LEADTYPE?.map((initial: any) => {
                        return {
                          value: initial?.value,
                          label: initial?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                      marginTop: 20,
                    }}
                  >
                    <RippleButton
                      id={"ClearContactDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="error"
                      style={{ marginRight: 10 }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        dispatch(clearLeadFilterDetails());
                      }}
                    >
                      Clear
                    </RippleButton>
                    <ButtonForAll
                      id={"LeadSubmitBtn"}
                      label={"Filter"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                    />

                    <RippleButton
                      id={"ClearLeadDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => setExpand("")}
                    >
                      Cancel
                    </RippleButton>
                  </GridLayoutItem>
                </GridLayout>
              )}
            </ExpansionPanel>
            {
              <Button
                style={{ opacity: 0, position: "absolute", left: -50 }}
                ref={BTNRef}
                type="submit"
                disabled={!formRenderProps.allowSubmit || loading}
              >
                Filter
              </Button>
            }
          </FormElement>
        )}
      />
    </>
  );
};

export default LeadFilter;
